import { ActionOrTriggerListTypeEnum, appPackagesStoreV2, IActionOrTriggerListPageParams } from '@app/static/'
import { toProxy } from '@fanfanlo'
import { AppIcon30 } from '../../../components'
import { childToProjectDataUtils, IChildToProjectData } from '@droid/project-v2-interface'
import { TriggerActionGroupContext, ProjectContext, ActionGroupContext, TriggerActionContext } from '@droid/project-v2-interface'
import { Box, Button, Grid2, Typography } from '@mui/material'
import { useRouter } from 'next/router'
import { PropsWithChildren, useContext, useEffect } from 'react'
import { actionOpenAppUtils, IActionOpenAppData } from './IActionOpenApp.inft'
import { useTranslation } from '@fanfanlo'

function UpdateAppLink({ data, children }: { data: IActionOpenAppData } & PropsWithChildren) {
    // 使用 useContext 获取所需的数据
    const project = useContext(ProjectContext)
    const triggerActionGroup = useContext(TriggerActionGroupContext)
    const triggerAction = useContext(TriggerActionContext)
    const actionGroup = useContext(ActionGroupContext)

    // 检查必需的数据是否存在
    if (
        !project?.ulid ||
        !triggerActionGroup?.ulid ||
        !triggerAction?.ulid ||
        !actionGroup?.ulid
    ) {
        console.error('UpdateAppLink: Required context data is undefined', {
            project: project?.ulid,
            triggerActionGroup: triggerActionGroup?.ulid,
            triggerAction: triggerAction?.ulid,
            actionGroup: actionGroup?.ulid
        })
        return null
    }

    const router = useRouter()
    const backPath = router.pathname
    const query: IActionOrTriggerListPageParams = {
        backPath,
        projectUlid: project.ulid,
        triggerActionGroupUlid: triggerActionGroup.ulid,
        triggerActionUlid: triggerAction.ulid,
        actionGroupUlid: actionGroup.ulid,
        type: ActionOrTriggerListTypeEnum.updateAction,
        actionUlid: data.ulid,
        actionType: actionOpenAppUtils.type,
    }

    const param = new URLSearchParams([...(Object.entries(query) as [string, string][])])
    const p = `/action-list/app-selector?${param.toString()}`
    useEffect(() => {
        router.prefetch(p)
    }, [])

    function onLinkClick() {
        router.push(p)
    }

    return (
        <Button id="open-app-action-change-app-btn" data-id="open-app-action-change-app-btn" data-testid="OpenAppActionUI__changeButton__01JFXYZI0Y4Z5A6B7C8D9E0F1" onClick={onLinkClick}>
            {children}
        </Button>
    )
}

export function IActionOpenAppUI(data: IActionOpenAppData) {
    const { t } = useTranslation('droid/project-v2-ext/actions/app/action-open-app/content')
    const packageInfo = appPackagesStoreV2.findPackageInfoByPackageName(data.javaData.packageName)

    function onDeleteComfirmed() {
        const projectData: IChildToProjectData = {}
        childToProjectDataUtils.actionList.getActionListByProp(data, projectData)
        const list = projectData.actionList
        if (!list) {
            throw new Error('actionList is undefined')
        }
        const index = list.findIndex(a => a.ulid === data.ulid)
        if (index === -1) {
            throw new Error('action not found')
        }
        toProxy(list).splice(index, 1)
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box>
                <b>{t('IActionOpenApp.openApp')}</b>
            </Box>
            <Grid2 container sx={{ width: '100%' }}>
                <Grid2 size="grow" container>
                    <Grid2>
                        <AppIcon30 packageName={data.javaData.packageName} />
                    </Grid2>
                    <Grid2>
                        <Typography sx={{}}>
                            <span style={{ display: 'inline-block', textIndent: '10px' }}>{packageInfo?.label}</span>
                            <span style={{ display: 'inline-block', textIndent: '10px', fontSize: '0.8rem' }}>
                                {packageInfo?.packageName}
                            </span>
                        </Typography>
                    </Grid2>
                </Grid2>
                <Grid2 size={'auto'}>
                    <UpdateAppLink data={data}>
                        <span>{t('IActionOpenApp.reselect')}</span>
                    </UpdateAppLink>
                </Grid2>
            </Grid2>
        </Box>
    )
}
